import React from 'react';
import PropTypes from 'prop-types';

import JBImage from 'components/essentials/JBImage';

const ConsumerPressArticles = ({ config }) => {
  const { title, articles } = config;

  return (
    <div className="m-8">
      {title && (
        <div
          className="text-[2.75rem] font-bold tracking-[-.75px] leading-[1.2] text-center mt-0 mx-auto mb-10"
          style={title.style}
        >
          {title.name.split('\n').map(it => (
            <h2 key={it}>{it}</h2>
          ))}
        </div>
      )}
      {articles && (
        <div className="flex flex-wrap">
          {articles.map(article => (
            <div
              key={article.link}
              className="w-[23%] p-8 min-h-[420px] mr-[2%] mb-10 bg-gray-light9 max-[1440px]:w-[31%] max-[1023px]:w-[48%] max-[680px]:w-full max-[680px]:mr-0"
            >
              <JBImage {...article.imgProps} />
              <div className="mt-4 text-[#74777a] font-bold pl-4 tracking-[-.13px] leading-[22px] [border-left:6px_solid_#e5e5e5]">
                {article.content}
              </div>
              <div className="pl-5 mt-[.825rem] [&_a]:text-[#585858] [&_a]:font-bold [&_a]:leading-[28px] [&_a]:tracking-[-.13px] [&_a]:no-underline [&_a]:ml-[-5px] [&_a:after]:[content:'→'] [&_a:after]:ml-[5px] [&_a:after]:absolute [&_a:after]:mt-0.5 [&_a:after]:transition-[all_.2s_ease-in-out] [&_a:hover:after]:hover:ml-2 [&_a:hover:after]:hover:transition-[all_.2s_ease-in-out]">
                <a href={article.link}>Read full article</a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

ConsumerPressArticles.propTypes = {
  config: PropTypes.shape({
    title: PropTypes.shape({
      name: PropTypes.string,
      style: PropTypes.object,
    }),
    articles: PropTypes.arrayOf(
      PropTypes.shape({
        content: PropTypes.string,
        link: PropTypes.string,
        imgProps: PropTypes.object,
      })
    ),
  }),
};

export default ConsumerPressArticles;
